import React from 'react';
import AppService from '../../services/app.service';

interface IProps {
}

interface IState {
}

export default class BaseValidate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        
    }
    
    public static validate(datarow: any, validations: any) {
        var errors : any;
        
        validations?.map((d: any) => {
            const name = d.name;
            const nameCapitalize  = AppService.strCapitalize(d.nameAlias || name);

            if (!errors?.[name]) {
                if (d.required && ['', null].includes(datarow[name])) {
                    if (!errors) errors = {}
                    errors[name] =  nameCapitalize+ ' cannot be blank'
                }
                else if (d.minLength && datarow[name]?.length < d.minLength) {
                    if (!errors) errors = {}
                    errors[name] = nameCapitalize+ ' must be at least ' +d.minLength+ ' characters';
                }
                else if (d.minValue && datarow[name] < d.minValue) {
                    if (!errors) errors = {}
                    errors[name] = nameCapitalize+ ' must be at least ' +d.minValue;
                }
                else if (d.maxValue && datarow[name] > d.maxValue) {
                    if (!errors) errors = {}
                    errors[name] = nameCapitalize+ ' exceeds the maximum value (' +d.maxValue+ ')';
                }
            }
        })

        return errors;
    } 
     
    render() {
        return <></>;
    }     
     
}